export default {
  title: "Документы",
  instruction: "Инструкция",
};
